export const FoldersSelector = (state) => state.folders;
